// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"a6ab49b3","836":"ed24a968"}[chunkId] + ".chunk.js";
};